const {LANG_COMMON} = require ('./../../languageIdList')

const customLanguages = `
# Языки

Вы можете говорить, читать и писать на [всеобщем](LANG:${LANG_COMMON}) и одном другом языке, который Вы и Ваш Мастер договоритесь считать подходящим для Вашего персонажа.
`

module.exports = customLanguages
